import { ChevronDown, LogOut, Menu, PanelLeftClose, UserRound } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { useMerchantStore } from '../../stores/merchantStore'
import { Button } from '../ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu'
import type { ReactNode } from 'react'

interface HeaderProps {
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  announcementHeader?: ReactNode
  mobileNavigationTrigger?: ReactNode
}

export default function Header({ collapsed, setCollapsed, announcementHeader, mobileNavigationTrigger }: HeaderProps) {
  const navigate = useNavigate()
  const { logout, merchant: authMerchant } = useAuthStore(state => ({ logout: state.logout, merchant: state.merchant }))
  const merchant = useMerchantStore(state => state.merchant)
  const merchantName = merchant?.name || merchant?.email || authMerchant?.name || authMerchant?.email || '商戶'
  const handleLogout = () => { logout(); navigate('/') }
  return (
    <header aria-label="商戶頂部欄" className="dashboard-header sticky top-0 z-20 flex min-h-16 items-center justify-between gap-2 border-b border-border bg-white px-3 sm:px-5 lg:px-8">
      <div className="flex shrink-0 items-center gap-3">
        {mobileNavigationTrigger || <Button variant="ghost" size="icon" aria-label={collapsed ? '展開側邊欄' : '收起側邊欄'} aria-expanded={!collapsed} aria-controls="desktop-navigation" onClick={() => setCollapsed(!collapsed)}>{collapsed ? <Menu className="size-4" /> : <PanelLeftClose className="size-4" />}</Button>}
        <div className="hidden sm:block"><p className="text-[10px] tracking-widest text-muted-foreground">KYRENPAY</p><p className="text-sm font-medium text-foreground">商戶工作台</p></div>
      </div>
      <div className="flex min-w-0 flex-1 items-center justify-end gap-2 sm:gap-4">
        {announcementHeader}
        <DropdownMenu>
          <DropdownMenuTrigger className="header-user flex shrink-0 items-center gap-2 rounded-lg p-1.5 text-sm text-foreground hover:bg-muted focus-visible:outline-2 focus-visible:outline-primary" aria-label={`商戶帳戶：${merchantName}`}>
            <span className="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/8 text-primary">{merchant?.logo ? <img src={merchant.logo} alt="" className="size-full object-cover" /> : <UserRound className="size-4" aria-hidden="true" />}</span>
            <span className="hidden max-w-36 truncate sm:block">{merchantName}</span><ChevronDown className="size-3.5 text-muted-foreground" aria-hidden="true" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => navigate('/dashboard/settings')}><UserRound className="size-4" aria-hidden="true" />賬戶設定</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}><LogOut className="size-4" aria-hidden="true" />退出登入</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  )
}
